/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MediaSourceQualityIssue
 */
export interface MediaSourceQualityIssue {
    /**
     * 
     * @type {MediaSourceQualityIssueReasonEnum}
     * @memberof MediaSourceQualityIssue
     */
    reason?: MediaSourceQualityIssueReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof MediaSourceQualityIssue
     */
    integrationId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MediaSourceQualityIssue
     */
    accountId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MediaSourceQualityIssue
     */
    campaignId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MediaSourceQualityIssue
     */
    premiseId?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof MediaSourceQualityIssue
     */
    day?: Date;
}


/**
 * @export
 */
export const MediaSourceQualityIssueReasonEnum = {
    ClassificationUnknown: 'classification_unknown',
    FenixCoverageMissing: 'fenix_coverage_missing',
    FenixCoveragePartial: 'fenix_coverage_partial',
    FenixCurrentDayValidatedPartial: 'fenix_current_day_validated_partial',
    FenixUnavailable: 'fenix_unavailable',
    SourceIdentityAmbiguous: 'source_identity_ambiguous',
    FenixGenerationMismatch: 'fenix_generation_mismatch',
    MediaSourceQualityUnknown: 'media_source_quality_unknown'
} as const;
export type MediaSourceQualityIssueReasonEnum = typeof MediaSourceQualityIssueReasonEnum[keyof typeof MediaSourceQualityIssueReasonEnum];


/**
 * Check if a given object implements the MediaSourceQualityIssue interface.
 */
export function instanceOfMediaSourceQualityIssue(value: object): value is MediaSourceQualityIssue {
    return true;
}

export function MediaSourceQualityIssueFromJSON(json: any): MediaSourceQualityIssue {
    return MediaSourceQualityIssueFromJSONTyped(json, false);
}

export function MediaSourceQualityIssueFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaSourceQualityIssue {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'] == null ? undefined : json['reason'],
        'integrationId': json['integrationId'] === undefined ? undefined : json['integrationId'] === null ? null : json['integrationId'],
        'accountId': json['accountId'] === undefined ? undefined : json['accountId'] === null ? null : json['accountId'],
        'campaignId': json['campaignId'] === undefined ? undefined : json['campaignId'] === null ? null : json['campaignId'],
        'premiseId': json['premiseId'] === undefined ? undefined : json['premiseId'] === null ? null : json['premiseId'],
        'day': json['day'] == null ? undefined : (new Date(json['day'])),
    };
}

export function MediaSourceQualityIssueToJSON(json: any): MediaSourceQualityIssue {
    return MediaSourceQualityIssueToJSONTyped(json, false);
}

export function MediaSourceQualityIssueToJSONTyped(value?: MediaSourceQualityIssue | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': value['reason'],
        'integrationId': value['integrationId'],
        'accountId': value['accountId'],
        'campaignId': value['campaignId'],
        'premiseId': value['premiseId'],
        'day': value['day'] == null ? value['day'] : value['day'].toISOString().substring(0,10),
    };
}

